// extracted by mini-css-extract-plugin
export default {"data-section":"AssignedCounsellor_data-section__gZK75"};